// components/NavbarEffects.tsx

'use client';

import { useBonuses } from '@/features/v2/shared/Header/navbars/navbarPrivate/hooks/useBonuses';
import { useFingerprint } from '@/features/v2/shared/Header/navbars/navbarPrivate/hooks/useFingrtprint';
import { useRouteLogic } from '@/features/v2/shared/Header/navbars/navbarPrivate/hooks/useRouteLogic';
import { useSolitics } from '@/features/v2/shared/Header/navbars/navbarPrivate/hooks/useSolitics';

export const NavbarEffects = () => {
  useFingerprint();
  useBonuses();
  useSolitics();
  useRouteLogic();

  // Este componente no renderiza nada, solo ejecuta efectos
  return null;
};
